export const DEFAULT_FONT_STACK =
  "'Roboto', 'Montserrat', Helvetica, Arial, sans-serif";
